import React from 'react'
import { Text, Button } from 'components/base'

type LayoutWrapperProps = {
  children: React.ReactNode
}

export function LayoutWrapper({ children }: LayoutWrapperProps) {
  return <div className="margin-vertical-larger">{children}</div>
}

export function LayoutSeparator() {
  return (
    <div className="width-full margin-vertical-large border-bottom-small border-shade-45" />
  )
}

type IconProps = {
  size?: number
  className?: string
}

type LayoutSectionProps = {
  Icon: React.ComponentType<IconProps>
  title: string
  subtitle: string
  children: React.ReactNode
}

export function LayoutSection({
  Icon,
  title,
  subtitle,
  children,
}: LayoutSectionProps) {
  const [isOpen, setIsOpen] = React.useState(false)

  const onToggle = React.useCallback(
    () => {
      setIsOpen(!isOpen)
    },
    [isOpen]
  )

  return (
    <div className="flexbox">
      <div className="margin-right-normal line-height-large">
        <Icon size={14} className="purple" />
      </div>
      <div className="flexbox-grow">
        <Text.Subtitle
          className="margin-bottom-normal pointer"
          onClick={onToggle}
        >
          {title}
        </Text.Subtitle>
        <Text.Corpus>{subtitle}</Text.Corpus>
        {isOpen ? children : null}
      </div>
      <div>
        <Button.Secondary slim onClick={onToggle}>
          {isOpen ? 'Close' : 'Expand'}
        </Button.Secondary>
      </div>
    </div>
  )
}
